exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".album {\n    transition: all 0.2s linear 0s;\n}\n\n.album:hover {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n}", ""]);

// exports
